import { USER_ROLES } from '~/features/auth/roles';

export const REAL_IDN_ID = '019b2413-a2ea-718a-b6d9-de2b73a070cb' as const;
const REAL_IDN_NAME = 'Micaela Hackett' as const;

export const REAL_IDN_IDS = [
  REAL_IDN_ID,
  '019b2413-b18d-71bd-b63c-134c635d360d',
] as const;
export const REAL_IDN_NAMES = [REAL_IDN_NAME, 'Donny Collins'] as const;

export const REAL_DEPARTMENT_ID =
  '019b2413-c3ef-764d-9393-8ca78cf73e65' as const;

const REAL_DEPARTMENT_NAME =
  'Department Nationwide Mutual Insurance Company' as const;

export const REAL_DEPARTMENT_IDS = [
  REAL_DEPARTMENT_ID,
  '019b2413-b2f4-7b4a-bb96-a0ca837e8a58',
] as const;
export const REAL_DEPARTMENT_NAMES = [
  REAL_DEPARTMENT_NAME,
  'Department AccuWeather',
] as const;

export const REAL_USERS = [
  {
    firstName: 'Meggie',
    lastName: 'Hills',
    email: 'customer.hcpadmin@abbott.com',
    role: USER_ROLES.HcpAdmin,
    idnId: REAL_IDN_ID,
    idnName: REAL_IDN_NAME,
    departmentId: REAL_DEPARTMENT_ID,
    departmentName: REAL_DEPARTMENT_NAME,
    id: '019b2413-a677-7e9e-b346-0c358552e97f',
  },
  {
    firstName: 'Kaycee',
    lastName: 'Deckow',
    email: 'abbott.admin@abbott.com',
    role: USER_ROLES.AdminAbbott,
    id: '019b2417-9cfa-7908-a455-7078abb5f8ed',
  },
  {
    firstName: 'Jazmyn',
    lastName: 'Lynch',
    email: 'abbott.user@abbott.com',
    role: USER_ROLES.AbbottUser,
    id: '019b2413-979f-7d2f-a4bc-ef2fd0800abd',
  },
  {
    firstName: 'Mitchell',
    lastName: 'Greenfelder',
    email: 'customer.admin@abbott.com',
    role: USER_ROLES.NonHcpAdmin,
    idnId: REAL_IDN_ID,
    idnName: REAL_IDN_NAME,
    departmentId: REAL_DEPARTMENT_ID,
    departmentName: REAL_DEPARTMENT_NAME,
    id: '019b2413-b51c-7cd9-bc44-f8ab70aaffe6',
  },
  {
    firstName: 'Rashad',
    lastName: 'Ledner',
    email: 'customer.hcp@abbott.com',
    role: USER_ROLES.HcpUser,
    idnId: REAL_IDN_ID,
    idnName: REAL_IDN_NAME,
    departmentId: REAL_DEPARTMENT_ID,
    departmentName: REAL_DEPARTMENT_NAME,
    id: '019b2413-c615-7c25-808b-5938e581f94a',
  },
];
